export default "/images/silent-hill-main.png";